import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { ExtendedAttributeOption } from '../models/extended-attribute-option';

export class SetExtendedAttributeOption {
    static readonly type = '[ExtendedAttributeOption] SetExtendedAttributeOption';

    constructor(public payload: ExtendedAttributeOption) {}
}

export class CreateExtendedAttributeOption {
    static readonly type = '[ExtendedAttributeOption] CreateExtendedAttributeOption';

    constructor(
        public payload: {
            attributeId: string;
            entity: ExtendedAttributeOption;
        }
    ) {}
}

export class CreateExtendedAttributeOptionSuccess {
    static readonly type = '[ExtendedAttributeOption] CreateExtendedAttributeOptionSuccess';

    constructor(public payload: ExtendedAttributeOption) {}
}

export class CreateExtendedAttributeOptionFailure {
    static readonly type = '[ExtendedAttributeOption] CreateExtendedAttributeOptionFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateExtendedAttributeOption {
    static readonly type = '[ExtendedAttributeOption] UpdateExtendedAttributeOption';

    constructor(public payload: ExtendedAttributeOption) {}
}

export class UpdateExtendedAttributeOptionSuccess {
    static readonly type = '[ExtendedAttributeOption] UpdateExtendedAttributeOptionSuccess';

    constructor(public payload: ExtendedAttributeOption) {}
}

export class UpdateExtendedAttributeOptionFailure {
    static readonly type = '[ExtendedAttributeOption] UpdateExtendedAttributeOptionFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeleteExtendedAttributeOption {
    static readonly type = '[ExtendedAttributeOption] DeleteExtendedAttributeOption';

    constructor(public payload: string) {}
}

export class DeleteExtendedAttributeOptionSuccess {
    static readonly type = '[ExtendedAttributeOption] DeleteExtendedAttributeOptionSuccess';

    constructor(public payload: string) {}
}

export class DeleteExtendedAttributeOptionFailure {
    static readonly type = '[ExtendedAttributeOption] DeleteExtendedAttributeOptionFailure';

    constructor(public payload: string) {}
}

export class SetExtendedAttributeOptions {
    static readonly type = '[ExtendedAttributeOption] SetExtendedAttributeOptions';

    constructor(public payload: ExtendedAttributeOption[]) {}
}

export class FetchExtendedAttributeOptions {
    static readonly type = '[ExtendedAttributeOption] FetchExtendedAttributeOptions';
}

export class FetchExtendedAttributeOptionsSuccess {
    static readonly type = '[ExtendedAttributeOption] FetchExtendedAttributeOptionsSuccess';
}

export class FetchExtendedAttributeOptionsFailure {
    static readonly type = '[ExtendedAttributeOption] FetchExtendedAttributeOptionsFailure';
}

export class FetchAllExtendedAttributeOptions {
    static readonly type = '[ExtendedAttributeOption] FetchAllExtendedAttributeOptions';

    constructor(public payload: string) {}
}

export class FetchAllExtendedAttributeOptionsSuccess {
    static readonly type = '[ExtendedAttributeOption] FetchAllExtendedAttributeOptionsSuccess';
}

export class FetchAllExtendedAttributeOptionsFailure {
    static readonly type = '[ExtendedAttributeOption] FetchAllExtendedAttributeOptionsFailure';
}
